<hum-top-gradient></hum-top-gradient>
<ion-content  [scrollY]="false" [fullscreen]="true">
	<div class="hum-content back-button-wrapper">
		<hum-back-button class="back-button" [defaultHref]="defaultHref"></hum-back-button>
	</div>
	<div class="page hum-content">
		<div class="top">
			<div class="title">{{ 'onboarding.birthdaytime.title' | translate }}</div>

			<hum-datetime
				[formControl]="birthday_date"
				[presentation]="'time'"
				class="field"
			></hum-datetime>

			<div class="caption">{{ 'onboarding.birthdaytime.caption' | translate }}</div>
		</div>
	</div>
	<div class="footer">
		<hum-button (click)="navigateNext()" class="hum-content">
			{{ 'onboarding.birthdaytime.next_button' | translate }}
		</hum-button>
	</div>
	<hum-bottom-gradient></hum-bottom-gradient>
</ion-content>
